import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseEmailTemplatesComponent, TemplateParameters } from '../../base-email-templates-landing-page.component';
import { AssetsUserDetailsService, FirearmAssignmentService, TransferAssetService } from 'assets-service';


@Component({
  selector: 'firearm-assignment-issue-police-notify-email-templates',
  templateUrl: './firearm-assignment-issue-police-notify-email-template.component.html',
  styleUrls: ['./firearm-assignment-issue-police-notify-email-template.component.scss']
})
export class FirearmAssignmentIssuePoliceNotifyEmailTemplatesComponent extends BaseEmailTemplatesComponent {

  constructor(private firearmAssignmentService: FirearmAssignmentService) {
    super();
  }

  protected getExampleTemplateParameters(backgroundServiceCall?: boolean): Observable<TemplateParameters> {
    return this.firearmAssignmentService.exampleNotifyPoliceTemplateParameters(true, backgroundServiceCall);
  }


}
